"use client"

import { Heading5 } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `Heading5Icon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const Heading5Icon = component(Icon)({ as: Heading5 })
